export default __webpack_public_path__ + "static/media/archive-tool-old.6eef30ab.svg";